import { makeStyles, tokens } from "@fluentui/react-components";

export const useTestSparklineStyles = makeStyles({
    svg: { display: "block" },
    empty: { color: tokens.colorNeutralForeground3, fontSize: "13px" },
});
